<section class="grid-x {{article().attributes.bg}}-content">
  <div class="container temp-spacer grid-x grid-margin-x article">
    @if (article().attributes.fileLink && article().attributes.imageIsFile) {
      <aside
        [@loadTriggerLeft]="'inLeft'"
        class="cell large-4 article__image--left">
        <div class="article__image--content" [ngStyle]="{'background-image': 'url(' + image  + ')'}"></div>
        @if (article().attributes.picture_text) {
          <small class="article__image--subtext">{{article().attributes.picture_text}}</small>
        }
      </aside>
    }
    @if (article().attributes.image && !article().attributes.imageIsFile) {
      <aside
        [@loadTriggerLeft]="'inLeft'"
        class="cell large-4 article__image--left">
        <div class="article__image--content" [ngStyle]="{'background-image': 'url(' + (image | async)  + ')'}"></div>
        @if (article().attributes.picture_text) {
          <small class="article__image--subtext">{{article().attributes.picture_text}}</small>
        }
      </aside>
    }
    <article [@loadTriggerLeft]="'inLeft'" class="article__main cell"
      [ngClass]="article().attributes.image || article().attributes.fileLink ? 'large-8' : 'large-12'">
      <div class="article__content">
        <h3 class="center-text">{{article().attributes.title}}</h3>
        <p class="center-text">{{article().attributes.content}}</p>
      </div>

    </article>
  </div>
  @if (editMode()) {
    <div class="edit-buttons">
      <button class="button" (click)="editArticle()">edit</button>
      <button class="button" (click)="deleteArticle()">delete</button>
    </div>
  }
</section>

